import { render, staticRenderFns } from "./DivTextarea.vue?vue&type=template&id=ac9caece&scoped=true&"
import script from "./DivTextarea.vue?vue&type=script&lang=js&"
export * from "./DivTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DivTextarea.vue?vue&type=style&index=0&id=ac9caece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9caece",
  null
  
)

export default component.exports